import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const EyeFilled = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="eye filled icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 18"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12 12.482C13.933 12.482 15.5 10.915 15.5 8.98199C15.5 7.049 13.933 5.48199 12 5.48199C11.9115 5.48199 11.8237 5.48528 11.7369 5.49174C11.9043 5.78415 12 6.12289 12 6.48398C12 7.58855 11.1046 8.48398 9.99999 8.48398C9.48031 8.48398 9.00693 8.28577 8.65131 7.96084C8.55292 8.28389 8.5 8.62676 8.5 8.98199C8.5 10.915 10.067 12.482 12 12.482Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.227212 10.021C-0.0765512 9.37436 -0.0765512 8.62564 0.227212 7.97902C2.30325 3.5598 6.7943 0.5 12 0.5C17.2057 0.5 21.6968 3.5598 23.7728 7.97902C24.0766 8.62564 24.0766 9.37437 23.7728 10.021C21.6968 14.4402 17.2057 17.5 12 17.5C6.7943 17.5 2.30325 14.4402 0.227212 10.021ZM12 14.982C15.3137 14.982 18 12.2957 18 8.98199C18 5.66829 15.3137 2.98199 12 2.98199C8.68629 2.98199 6 5.66829 6 8.98199C6 12.2957 8.68629 14.982 12 14.982Z"
    />
  </svg>
)
